<template>
    <GDialog
        v-model="state.open"
        :max-width="480"
        transition="custom-from-bottom-transition"
    >
        <div class="p-6">
            <div class="flex items-start gap-3">
                <div class="flex-shrink-0 rounded-full p-3" :class="preset.iconBgClass">
                    <font-awesome-icon :icon="['fa', preset.icon]" :class="preset.iconClass" />
                </div>
                <div>
                    <h3 class="text-lg text-bold text-gray-900 dark:text-gray-100">{{ state.title }}</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">{{ state.message }}</p>
                </div>
            </div>
        </div>
        <hr class="border-gray-200 dark:border-gray-800">
        <div class="p-6">
            <div class="flex justify-end">
                <button
                    class="mr-2 bg-transparent hover:bg-gray-500 text-gray-700 font-semibold hover:text-white py-2 px-4 border text-sm border-gray-500 hover:border-transparent rounded-md dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
                    @click="handleCancel"
                >
                    {{ state.cancelText }}
                </button>
                <LoaderButton :title="state.confirmText" :defaultClass="preset.classButton" @ok="handleConfirm" ref="btnConfirm"></LoaderButton>
            </div>
        </div>
    </GDialog>
</template>

<script>

import LoaderButton from './../form/LoaderButton';
import confirmService from './../../common/confirm';

export default {
    components: {
        LoaderButton
    },
    data() {
        return {
            state: confirmService.state
        }
    },
    computed: {
        preset() {
            return confirmService.variants[this.state.variant];
        }
    },
    methods: {
        async handleConfirm() {
            this.$refs.btnConfirm.activateLoader();
            await confirmService.handleConfirm();
            this.$refs.btnConfirm?.deactivateLoader();
        },
        handleCancel() {
            confirmService.handleCancel();
        }
    }
};
</script>
